import $ from 'jquery';
import MeganavMenu from '../snippets/MeganavMenu';

export default class MobileNav {
  constructor(el) {
    this.$html = $('html');

    // Component elements
    this.$el = $(el);
    this.$panel = this.$el.find('.mobilenav-panel');
    this.$overlay = this.$el.find('.mobilenav-overlay');
    this.$content = this.$el.find('.mobilenav-panel-content');
    this.$animators = this.$el.find('[data-mobilenav-animator]');

    // Search elements
    this.$searchInput = this.$el.find('.mobilenav-search-input');
    this.$searchCancel = this.$el.find('.mobilenav-search-cancel');

    // Contact bar elements
    this.$contact = this.$el.find('.mobilenav-contactbar');

    this.$el.on('click.navmenu', '.navmenu-link-parent:not(.navmenu-link-meganav)', event => {
      this.toggleItem(event.currentTarget);
    });

    this.$el.on('click.navmenu', '.navmenu-arrow-toggle', event => {
      event.preventDefault();
      event.stopPropagation();
      this.arrowToggle(event.currentTarget);
    });

    this.$megaNavTriggers = this.$el.find('[data-meganav-trigger]');
    this.$megaNavs = this.$el.find('[data-meganav]');
    this.megaNavs = [];

    this.$megaNavTriggers.each((key, megaNavTrigger) => {
      const $megaNavTrigger = $(megaNavTrigger);
      const $megaNav = $megaNavTrigger.children('.meganav');
      this.megaNavs.push(new MeganavMenu($megaNav.get(0)));
    });

    this.events = [];
  }

  unload() {
    this.close();
    this.$el.off('.navmenu');
  }

  open() {
    this.$html.addClass('scroll-lock');

    // Animate in elements
    this.$animators
      .revealer('show')
      .one('revealer-show', () => this.$panel.css('display', ''));
    this.$panel.css('display', 'block');
    this.$searchInput.focus();

    // Event handlers
    this.events = [
      // Close menu when clicking on the overlay
      this.$overlay.on('click.mobilenav', event => this.close()),

      // Disable scrolling on overlay and contactbar
      this.$overlay.on('touchmove.mobilenav', event => event.preventDefault()),
      this.$contact.on('touchmove.mobilenav', event => event.preventDefault()),

      // Close keyboard when scrolling through the menu
      this.$content.on('touchmove.mobilenav', event => this.$searchInput.blur()),

      // Button to blur search input button
      this.$searchCancel.on('click.mobilenav', event => this.$searchInput.blur()),
    ];
  }

  close() {
    this.$html.removeClass('scroll-lock');

    // Unbind events
    this.events.forEach($el => $el.off('.mobilenav'));
    this.events = [];

    // Animate out items
    this.$animators.revealer('hide');
  }

  toggleItem(el) {
    const $el = $(el);

    if ($el.hasClass('navmenu-selected')) {
      return true;
    } else {
      event.preventDefault();
      $el.toggleClass('navmenu-selected');
      $el.parent().toggleClass('navmenu-active');
      const $menu = $el.siblings('.navmenu');
      $menu.slideToggle();
    }
  }

  arrowToggle(el) {
    const $el = $(el).parent();
    $el.toggleClass('navmenu-selected');
    $el.parent('').toggleClass('navmenu-active');
    const $menu = $el.siblings('.navmenu');
    $menu.slideToggle();
  }
}
